import { createThunkEffect } from "../../utilities/ActionUtility";
import * as SubscriptionEffect from "./SubscriptionEffect";

export const REQUEST_ALL_SUBSCRIPTION_FOLDERS = "SubscriptionEffect.REQUEST_ALL_SUBSCRIPTION_FOLDERS";
export const REQUEST_ALL_SUBSCRIPTION_FOLDERS_FINISHED = "SubscriptionEffect.REQUEST_ALL_SUBSCRIPTION_FOLDERS_FINISHED";

export function requestAllSubscriptionFolders() {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_SUBSCRIPTION_FOLDERS, SubscriptionEffect.requestAllSubscriptionFolders);
    };
}

export const REQUEST_ALL_SUBSCRIPTIONS = "SubscriptionEffect.REQUEST_ALL_SUBSCRIPTIONS";
export const REQUEST_ALL_SUBSCRIPTIONS_FINISHED = "SubscriptionEffect.REQUEST_ALL_SUBSCRIPTIONS_FINISHED";

export function requestAllSubscriptionTypes() {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_SUBSCRIPTIONS, SubscriptionEffect.requestSubscriptionTypes);
    };
}

export const REQUEST_USER_SUBSCRIPTIONS = "SubscriptionEffect.REQUEST_USER_SUBSCRIPTIONS";
export const REQUEST_USER_SUBSCRIPTIONS_FINISHED = "SubscriptionEffect.REQUEST_USER_SUBSCRIPTIONS_FINISHED";

export function requestUserSubscriptions(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_USER_SUBSCRIPTIONS, SubscriptionEffect.requestUserSubscriptions, userId);
    };
}

export const CREATE_SUBSCRIPTION = "SubscriptionEffect.CREATE_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION_FINISHED = "SubscriptionEffect.CREATE_SUBSCRIPTION_FINISHED";

export function createSubscriptionType(newSubscriptionType) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, CREATE_SUBSCRIPTION, SubscriptionEffect.createSubscriptionType, newSubscriptionType);
    };
}

export const UPDATE_SUBSCRIPTION = "SubscriptionEffect.UPDATE_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTION_FINISHED = "SubscriptionEffect.UPDATE_SUBSCRIPTION_FINISHED";

export function updateSubscriptionType(subscriptionTypeId, newSubscriptionType) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, UPDATE_SUBSCRIPTION, SubscriptionEffect.updateSubscriptionType, subscriptionTypeId, newSubscriptionType);
    };
}

export const DELETE_SUBSCRIPTION = "SubscriptionEffect.DELETE_SUBSCRIPTION";
export const DELETE_SUBSCRIPTION_FINISHED = "SubscriptionEffect.DELETE_SUBSCRIPTION_FINISHED";

export function deleteSubscriptionType(subscriptionTypeId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch,DELETE_SUBSCRIPTION, SubscriptionEffect.deleteSubscriptionType, subscriptionTypeId);
    };
}

export const REQUEST_SUBSCRIPTION_USERS = "SubscriptionEffect.REQUEST_SUBSCRIPTION_USERS";
export const REQUEST_SUBSCRIPTION_USERS_FINISHED = "SubscriptionEffect.REQUEST_SUBSCRIPTION_USERS_FINISHED";

export function requestSubscriptionUsers(subscriptionId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SUBSCRIPTION_USERS, SubscriptionEffect.requestSubscriptionUsers, subscriptionId);
    };
}

export const ADD_SUBSCRIPTION_USERS = "SubscriptionEffect.ADD_SUBSCRIPTION_USERS";
export const ADD_SUBSCRIPTION_USERS_FINISHED = "SubscriptionEffect.ADD_SUBSCRIPTION_USERS_FINISHED";

export function addSubscriptionUser(subscriptionId, userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, ADD_SUBSCRIPTION_USERS, SubscriptionEffect.addSubscriptionUser, subscriptionId, userId);
    };
}

export const DELETE_SUBSCRIPTION_USER = "SubscriptionEffect.DELETE_SUBSCRIPTION_USER";
export const DELETE_SUBSCRIPTION_USER_FINISHED = "SubscriptionEffect.DELETE_SUBSCRIPTION_USER_FINISHED";

export function deleteSubscriptionUser(subscriptionId, userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, DELETE_SUBSCRIPTION_USER, SubscriptionEffect.deleteSubscriptionUser, subscriptionId, userId);
    };
}

export const REQUEST_USER_UNASSIGNED_SUBSCRIPTION_TYPES = "SubscriptionEffect.REQUEST_USER_UNASSIGNED_SUBSCRIPTION_TYPES";
export const REQUEST_USER_UNASSIGNED_SUBSCRIPTION_TYPES_FINISHED = "SubscriptionEffect.REQUEST_USER_UNASSIGNED_SUBSCRIPTION_TYPES_FINISHED";

export function requestUserUnassignedSubscriptionTypes(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_USER_UNASSIGNED_SUBSCRIPTION_TYPES, SubscriptionEffect.requestUserUnassignedSubscriptionTypes, userId);
    };
}

// Date ranges
export const REQUEST_USER_DATE_RANGES = "SubscriptionEffect.REQUEST_USER_DATE_RANGES";
export const REQUEST_USER_DATE_RANGES_FINISHED = "SubscriptionEffect.REQUEST_USER_DATE_RANGES_FINISHED";

export function requestUserDateRanges(subscriptionId, userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_USER_DATE_RANGES, SubscriptionEffect.requestUserDateRanges, subscriptionId, userId);
    };
}

export const REQUEST_ALL_USER_DATE_RANGES = "SubscriptionEffect.REQUEST_ALL_USER_DATE_RANGES";
export const REQUEST_ALL_USER_DATE_RANGES_FINISHED = "SubscriptionEffect.REQUEST_ALL_USER_DATE_RANGES_FINISHED";

export function requestAllUserDateRanges(userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_USER_DATE_RANGES, SubscriptionEffect.requestAllUserDateRanges, userId);
    };
}

export const REQUEST_COPY_ALL_USER_DATE_RANGES = "SubscriptionEffect.REQUEST_COPY_ALL_USER_DATE_RANGES";
export const REQUEST_COPY_ALL_USER_DATE_RANGES_FINISHED = "SubscriptionEffect.REQUEST_COPY_ALL_USER_DATE_RANGES_FINISHED";

export function copyAllUserDateRanges(userId, users) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_COPY_ALL_USER_DATE_RANGES, SubscriptionEffect.copyAllUserDateRanges, userId, users);
    };
}

export const ADD_USER_DATE_RANGE = "SubscriptionEffect.ADD_USER_DATE_RANGE";
export const ADD_USER_DATE_RANGE_FINISHED = "SubscriptionEffect.ADD_USER_DATE_RANGE_FINISHED";

export function addUserDateRange(subscriptionId, userId, dateRange) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, ADD_USER_DATE_RANGE, SubscriptionEffect.addUserDateRange, subscriptionId, userId, dateRange);
    };
}

export const UPDATE_USER_DATE_RANGE = "SubscriptionEffect.UPDATE_USER_DATE_RANGE";
export const UPDATE_USER_DATE_RANGE_FINISHED = "SubscriptionEffect.UPDATE_USER_DATE_RANGE_FINISHED";

export function updateUserDateRange(subscriptionId, userId, dateRangeId, dateRange) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, UPDATE_USER_DATE_RANGE, SubscriptionEffect.updateUserDateRange, subscriptionId, userId, dateRangeId, dateRange);
    };
}

export const REQUEST_COPY_USER_DATE_RANGE = "SubscriptionEffect.REQUEST_COPY_USER_DATE_RANGE";
export const REQUEST_COPY_USER_DATE_RANGE_FINISHED = "SubscriptionEffect.REQUEST_COPY_USER_DATE_RANGE_FINISHED";

export function copyUserDateRange(subscriptionId, userId, dateRangeId, users) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_COPY_USER_DATE_RANGE, SubscriptionEffect.copyUserDateRange, subscriptionId, userId, dateRangeId, users);
    };
}

export const DELETE_USER_DATE_RANGE = "SubscriptionEffect.DELETE_USER_DATE_RANGE";
export const DELETE_USER_DATE_RANGE_FINISHED = "SubscriptionEffect.DELETE_USER_DATE_RANGE_FINISHED";

export function deleteUserDateRange(subscriptionId, userId, dateRangeId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, DELETE_USER_DATE_RANGE, SubscriptionEffect.deleteUserDateRange, subscriptionId, userId, dateRangeId);
    };
}

// Visibility date
export const SET_USER_VISIBILITY_DATE = "SubscriptionEffect.SET_USER_VISIBILITY_DATE";
export const SET_USER_VISIBILITY_DATE_FINISHED = "SubscriptionEffect.SET_USER_VISIBILITY_DATE_FINISHED";

export function setUserVisibilityDate(subscriptionTypeId, userId, visibilityStartDate) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, SET_USER_VISIBILITY_DATE, SubscriptionEffect.setUserVisibilityDate, subscriptionTypeId, userId, visibilityStartDate);
    };
}

export const DELETE_USER_VISIBILITY_DATE = "SubscriptionEffect.DELETE_USER_VISIBILITY_DATE";
export const DELETE_USER_VISIBILITY_DATE_FINISHED = "SubscriptionEffect.DELETE_USER_VISIBILITY_DATE_FINISHED";

export function deleteUserVisibilityDate(subscriptionTypeId, userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, DELETE_USER_VISIBILITY_DATE, SubscriptionEffect.deleteUserVisibilityDate, subscriptionTypeId, userId);
    };
}

// Contacts
export const REQUEST_SUBSCRIPTION_CONTACTS = "SubscriptionEffect.REQUEST_SUBSCRIPTION_CONTACTS";
export const REQUEST_SUBSCRIPTION_CONTACTS_FINISHED = "SubscriptionEffect.REQUEST_SUBSCRIPTION_CONTACTS_FINISHED";

export function requestSubscriptionContacts(subscriptionId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SUBSCRIPTION_CONTACTS, SubscriptionEffect.requestSubscriptionContacts, subscriptionId);
    };
}

export const ADD_SUBSCRIPTION_CONTACT = "SubscriptionEffect.ADD_SUBSCRIPTION_CONTACT";
export const ADD_SUBSCRIPTION_CONTACT_FINISHED = "SubscriptionEffect.ADD_SUBSCRIPTION_CONTACT_FINISHED";

export function addSubscriptionContact(subscriptionId, email) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, ADD_SUBSCRIPTION_CONTACT, SubscriptionEffect.addSubscriptionContact, subscriptionId, email);
    };
}

export const UPDATE_SUBSCRIPTION_CONTACT = "SubscriptionEffect.UPDATE_SUBSCRIPTION_CONTACT";
export const UPDATE_SUBSCRIPTION_CONTACT_FINISHED = "SubscriptionEffect.UPDATE_SUBSCRIPTION_CONTACT_FINISHED";

export function updateSubscriptionContact(subscriptionId, contactId, email) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, UPDATE_SUBSCRIPTION_CONTACT, SubscriptionEffect.updateSubscriptionContact, subscriptionId, contactId, email);
    };
}

export const DELETE_SUBSCRIPTION_CONTACT = "SubscriptionEffect.DELETE_SUBSCRIPTION_CONTACT";
export const DELETE_SUBSCRIPTION_CONTACT_FINISHED = "SubscriptionEffect.DELETE_SUBSCRIPTION_CONTACT_FINISHED";

export function deleteSubscriptionContact(subscriptionId, contactId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, DELETE_SUBSCRIPTION_CONTACT, SubscriptionEffect.deleteSubscriptionContact, subscriptionId, contactId);
    };
}

// Reinitialization
export const REINITIALIZE_SUBSCRIPTION_TYPE = "SubscriptionEffect.REINITIALIZE_SUBSCRIPTION_TYPE";
export const REINITIALIZE_SUBSCRIPTION_TYPE_FINISHED = "SubscriptionEffect.REINITIALIZE_SUBSCRIPTION_TYPE_FINISHED";

export function reinitializeSubscriptionType(subscriptionTypeId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REINITIALIZE_SUBSCRIPTION_TYPE, SubscriptionEffect.reinitializeSubscriptionType, subscriptionTypeId);
    };
}

export const REINITIALIZE_USERS_SUBSCRIPTION = "SubscriptionEffect.REINITIALIZE_USERS_SUBSCRIPTION";
export const REINITIALIZE_USERS_SUBSCRIPTION_FINISHED = "SubscriptionEffect.REINITIALIZE_USERS_SUBSCRIPTION_FINISHED";

export function reinitializeUsersSubscription(subscriptionId, userId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REINITIALIZE_USERS_SUBSCRIPTION, SubscriptionEffect.reinitializeUsersSubscription, subscriptionId, userId);
    };
}

export const REINITIALIZE_AND_CLEAN = "SubscriptionEffect.REINITIALIZE_AND_CLEAN";
export const REINITIALIZE_AND_CLEAN_FINISHED = "SubscriptionEffect.REINITIALIZE_AND_CLEAN_FINISHED";

export function reinitializeAndClean(subscriptionTypeId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REINITIALIZE_AND_CLEAN, SubscriptionEffect.reinitializeAndClean, subscriptionTypeId);
    };
}

// Multiple subscriptions
export const CREATE_MULTIPLE_SUBSCRIPTIONS = "SubscriptionEffect.CREATE_MULTIPLE_SUBSCRIPTIONS";
export const CREATE_MULTIPLE_SUBSCRIPTIONS_FINISHED = "SubscriptionEffect.CREATE_MULTIPLE_SUBSCRIPTIONS_FINISHED";

export function createMultipleSubscriptions(multipleSubscriptionsData) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, CREATE_MULTIPLE_SUBSCRIPTIONS, SubscriptionEffect.createMultipleSubscriptions, multipleSubscriptionsData);
    };
}